import React from 'react'
import DraggableModal from '../../../generic/DraggableModal'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import { TableContainer, Table, TableRow, TableHead, TableBody, TableCell } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'

const RolesTable = () => {
  const permissions = {
    view: 'View dashboard',
    payment_requests: 'Can create/approve/cancel payment requests',
    edit_connections: 'Add/edit/delete account connections',
    invite: 'Invite/remove team members',
    limits: "Change team members' transaction limits",
    roles: 'Change team member roles',
  }

  const roles = [
    {
      name: 'Member',
      permissions: ['view', 'payment_requests'],
    },
    {
      name: 'Dashboard Editor',
      permissions: ['view', 'payment_requests', 'edit_connections'],
    },
    {
      name: 'Admin',
      permissions: Object.keys(permissions),
    },
  ]
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            {roles.map((role) => {
              return (
                <TableCell>
                  <Typography>{role.name}</Typography>
                </TableCell>
              )
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(permissions).map((perm) => {
            return (
              <TableRow>
                <TableCell>
                  <Typography>{permissions[perm]}</Typography>
                </TableCell>
                {roles.map((role) => {
                  return (
                    <TableCell align='center'>
                      {role.permissions.includes(perm) ? <CheckIcon fontSize='large' /> : <></>}
                    </TableCell>
                  )
                })}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const TeamRolesInfoModal = ({ visible, handleClose }) => {
  return (
    <DraggableModal
      modalVisible={visible}
      handleCancelModal={handleClose}
      modalTitle='Roles'
      width='auto'
      content={
        <RolesTable />
        // <Stack spacing={1}>
        //   <Stack>
        //     <Typography variant='h5'>Member:</Typography>
        //     <Typography sx={{ pl: 4 }}> User can read information on the dashboard.</Typography>
        //   </Stack>
        //   <Stack>
        //     <Typography variant='h5'>Admin:</Typography>
        //     <Typography sx={{ pl: 4 }}>User can manage team members and update transaction limits.</Typography>
        //   </Stack>

        //   <Stack>
        //     <Typography variant='h5'>Editor:</Typography>
        //     <Typography sx={{ pl: 4 }}>
        //       User can make changes, add, edit, and delete information and account connections in the dashboard.
        //     </Typography>
        //   </Stack>
        // </Stack>
      }
    />
  )
}

export default TeamRolesInfoModal
